import React from 'react'
import styles from './styles.module.css'

const CLICK_HINT = 'Нажмите, чтобы увидеть все аудитории и преподавателей'

// В ячейке остаётся первое значение и счётчик остальных: у потокового занятия
// бывает до двух десятков аудиторий и преподавателей (п. 6.3 ТЗ).
const Values = ({ items, className }) => {
  if (!items.length) return <span className={className} />
  const rest = items.length - 1
  return (
    <span className={className}>
      <span className={styles.value}>{items[0]}</span>
      {rest > 0 && <span className={styles.more}>ещё {rest}</span>}
    </span>
  )
}

const Lesson = ({ lesson, onOpen }) => {
  const body = (
    <span className={styles.lesson}>
      <span className={styles.discipline}>{lesson.alias}</span>
      <span className={styles.lessonType}>{lesson.typeAlias}</span>
      <Values items={lesson.rooms} className={styles.rooms} />
      <Values items={lesson.teachers} className={styles.teachers} />
    </span>
  )

  if (!onOpen) return body

  return (
    <button type="button" className={styles.clickable} title={CLICK_HINT} onClick={onOpen}>
      {body}
    </button>
  )
}

const Grid = ({ columns, days, onOpenLesson }) => (
  <div className={styles.scroll}>
    <table className={styles.table}>
      <thead>
        <tr>
          <th className={styles.fix1}>Дата</th>
          <th className={styles.fix2}>Часы занятий</th>
          {columns.map(column => (
            <th key={column.id} className={styles.colGroup}>{column.name} группа</th>
          ))}
          <th className={styles.filler} aria-hidden="true" />
        </tr>
      </thead>
      <tbody>
        {days.map(day => day.rows.map((row, rowIndex) => (
          <tr
            key={`${day.date}-${row.periodName}`}
            className={[
              day.isToday ? styles.today : '',
              rowIndex === day.rows.length - 1 ? styles.dayEnd : '',
            ].filter(Boolean).join(' ')}
          >
            {rowIndex === 0 && (
              <td
                className={`${styles.fix1} ${styles.date} ${day.isWeekend ? styles.weekend : ''}`}
                rowSpan={day.rows.length}
              >
                {day.dayNumber}
                <span className={styles.weekday}>{day.weekdayShort}</span>
                {day.isToday && <span className={styles.todayMark}>сегодня</span>}
              </td>
            )}

            <td className={`${styles.fix2} ${styles.hours} ${row.individual ? styles.hoursIndividual : ''}`}>
              <b>{row.individual ? 'инд. раб.' : row.periodName}</b>
              {row.periodTime}
            </td>

            {columns.map(column => {
              const lesson = row.cells[column.id]
              // клик открывает окно только у занятия с плашкой «ещё N» (п. 6.6 ТЗ)
              const hasMore = !!lesson && (lesson.rooms.length > 1 || lesson.teachers.length > 1)
              return (
                <td key={column.id} className={styles.cell}>
                  {lesson && (
                    <Lesson
                      lesson={lesson}
                      onOpen={hasMore
                        ? () => onOpenLesson(lesson, day, row, column)
                        : null}
                    />
                  )}
                </td>
              )
            })}

            <td className={styles.cell} />
          </tr>
        )))}
      </tbody>
    </table>
  </div>
)

export default Grid
